import { render } from "./SamlConfiguration.vue?vue&type=template&id=10ba0224&scoped=true&lang=pug"
import script from "./SamlConfiguration.vue?vue&type=script&lang=js"
export * from "./SamlConfiguration.vue?vue&type=script&lang=js"

import "./SamlConfiguration.vue?vue&type=style&index=0&id=10ba0224&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ba0224"]])

export default __exports__